import { ClubModel } from '@bayclubs/court-booking-employee-api';

export class ClubSelectFormModel {
    clubId: string;

    public static Init(club: ClubModel): ClubSelectFormModel{
        return {
            clubId: club.id
        };
    }
}
